import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-e7bea7e2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "second-show"
};
const _hoisted_2 = {
  class: "link-list"
};
const _hoisted_3 = {
  class: "text"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "更多", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shouqi1"
}, null, -1));

const _hoisted_6 = {
  class: "show-five"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "img-container"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "title-container"
};
const _hoisted_11 = {
  class: "describe-container"
};
const _hoisted_12 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CardHeader = _resolveComponent("CardHeader");

  return $data.trainList.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_CardHeader, {
    class: "course-header",
    bodyStyle: {
      background: 'none'
    },
    link: `/train.html?name=${$props.menu.module_name}&menuId=${$props.menu.menu_id}`
  }, {
    left: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString($props.menu.module_name), 1)])]),
    right: _withCtx(() => [_hoisted_4, _hoisted_5]),
    _: 1
  }, 8, ["link"]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.trainList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "card-container",
      style: {
        "height": "267.55px"
      },
      key: item.training_id,
      onClick: $event => $options.jumpTo($props.menu, item)
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
      src: item.cover_url,
      alt: "加载中..."
    }, null, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", null, _toDisplayString(item.train_project), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", {
      innerHTML: item.introduction
    }, null, 8, _hoisted_12)])], 8, _hoisted_7);
  }), 128))])])) : _createCommentVNode("", true);
}